import { TControlsIndent } from './types';

import * as styles from './Controls.css';

export const INDENT_TO_CLASS: { [key in TControlsIndent]: string } = {
  M: styles['middle-indent'],
  L: styles['large-indent'],
};
